const junoSound = {
  title: "音声ジェネレーター",
  menu: {
    music: "Music",
    sfx: "SFX",
    voice: "AI Voice",
    library: "ライブラリ",
  },
  ai: {
    select: "AIモデルを選択してください",
    model: "モデル",
    cassetteai: {
      title: "CassetteAI",
      description: "テキスト説明から高品質な音楽を生成するCassetteAIの強力な音楽生成モデルです。",
      category: ["音楽", "歌詞"],
    },
    cassetteai_sfx: {
      title: "CassetteAI SFX",
      description: "CassetteAIの特化した効果音生成モデルで、あらゆるシナリオに適したリアルな効果音を作成します。",
      category: ["効果音"],
    },
    diffrhythm: {
      title: "DiffRhythm",
      description: "高度な拡散モデル技術を使用して、正確なリズムコントロールとメロディを持つ音楽を作成します。",
      category: ["音楽", "歌詞"],
    },
    elevenlabs: {
      title: "ElevenLabs SFX",
      description: "あらゆるシナリオや環境に合わせた高忠実度のリアルな効果音を生成します。",
      category: ["効果音"],
    },
    minimax: {
      title: "MiniMax Music",
      description: "特に楽器トラックに最適化された、卓越した品質でさまざまなスタイルの音楽を作成します。",
      category: ["音楽", "歌詞"],
    },
    mmaudio: {
      title: "MMAudio",
      description: "多用途なオーディオ生成機能で、音楽と効果音の両方を生成します。",
      category: ["効果音", "音楽"],
    },
  },
  category: {
    music: "音楽",
    sfx: "効果音",
    lyric: "歌詞",
    reference: "参照",
  },
  params: {
    settings: "音声設定",
    ref: "参考音源",
    upload: "オーディオをアップロード",
    duration: "長さ（秒）",
    durationHelp: "生成する音声の長さを設定します（秒単位）",
    guidanceScale: "ガイダンススケール",
    guidanceScaleHelp: "音声生成における品質と創造性のバランスを調整します",
    step: "ステップ数",
    stepHelp: "ノイズ除去ステップ数を制御します。値が大きいほど生成時間が増えますが、品質が向上します",
    lyric: "歌詞",
    lyricPlaceholder: "音楽の歌詞を入力してください",
    lyricHelp: "音楽生成をガイドするための歌詞を追加します。構造を作るために改行などの書式を使用できます",
    lyricOnlyEnglish: "このモデルは英語の歌詞のみをサポート",
    negativePrompt: "ネガティブプロンプト",
    negativePromptPlaceholder: "音声に含めたくない要素を入力してください",
    negativePromptHelp: "生成される音声に含めたくない要素を指定します",
    category: "カテゴリ",
    categoryHelp: "生成したい音声のタイプを選択します",
    public: "公開する",
    publicHelp: "この音声をライブラリで他のユーザーが利用できるようにします",
    input: {
      label: "プロンプト",
      placeholder: "音声の説明を入力してください（英語推奨）",
      notRequired: "プロンプト入力は不要です",
      warning: "ポリシーに違反する音声は生成できず、そのような場合はクレジットは保証されません。",
      error: {
        button: "問題がありますか？",
        tooltip: "エラーが続く場合、プロバイダー側に問題がある可能性があります。しばらく待ってから再試行してください。",
      },
    },
    submit: "音声を生成",
  },
  mySounds: "マイ音声",
  processing: "音声を生成中...\n通常1〜2分で完了します。",
  sampleSounds: "サンプル音声",
  error: {
    generate: "音声の生成に失敗しました。\nポリシー違反がないか確認し、後でもう一度お試しください。",
    required: {
      prompt: "プロンプトを入力してください。",
      audio: "このモデルにはオーディオファイルのアップロードが必要です。",
    },
    max: {
      prompt: "プロンプトが長すぎるので、短くする必要があります。",
      audioSize: "オーディオファイルのサイズは30MB以下である必要があります。",
      audioDuration: "オーディオの長さは60秒以下である必要があります。",
    },
    processingLimit:
      "処理制限を超えました。現在{{current}}件のリクエストが進行中です。あなたのプランでは最大{{limit}}件の同時リクエストが許可されています。",
    prompt: {
      generate: "プロンプト生成エラー",
      update: "プロンプト強化エラー",
    },
  },
  startGenerating: "音声生成リクエストがキューに追加されました。",
  soundMenu: {
    download: "ダウンロード",
    delete: "削除",
  },
  message: {
    deleted: "音声が削除されました。",
    error: "エラー",
  },
  noImage: "画像がありません",
  inspire: {
    icon: "サウンドインスピレーション",
    description: "カテゴリをクリックしてプロンプトに追加",
    genre: {
      rock: "ロック",
      pop: "ポップ",
      hiphop: "ヒップホップ",
      jazz: "ジャズ",
      classical: "クラシック",
      electronic: "エレクトロニック",
      ambient: "アンビエント",
      blues: "ブルース",
      country: "カントリー",
      folk: "フォーク",
      reggae: "レゲエ",
      rnb: "R&B",
      metal: "メタル",
      punk: "パンク",
      indie: "インディー",
      latin: "ラテン",
    },
    mood: {
      happy: "明るい",
      sad: "悲しい",
      energetic: "エネルギッシュ",
      calm: "穏やか",
      relaxed: "リラックス",
      chill: "チル",
      dreamy: "夢のような",
      romantic: "ロマンチック",
      nostalgic: "懐かしい",
      dramatic: "ドラマチック",
      dark: "ダーク",
      emotional: "感情的",
      melancholic: "物悲しい",
      uplifting: "高揚感",
      epic: "壮大",
      mysterious: "神秘的",
    },
    sfx: {
      water: "水の音",
      wind: "風の音",
      rain: "雨の音",
      thunder: "雷",
      fire: "火の音",
      forest: "森の音",
      birds: "鳥の鳴き声",
      animals: "動物の音",
      ocean: "海の波",
      city: "都市の環境音",
      footsteps: "足音",
      machinery: "機械音",
      digital: "デジタル音",
      explosion: "爆発音",
      impact: "衝撃音",
      whoosh: "風切り音",
    },
    bpm: {
      slow: "遅い",
      medium: "普通",
      fast: "速い",
      apply: "BPMを適用",
    },
    dice: "サンプルプロンプト生成",
    improve: "プロンプト強化",
  },
};
export default junoSound;
